<div class="toast-container" [ngClass]="'toast-' + toast.type">
  <div class="flex items-center">
    <img *ngIf="toast.type === 'success'" src="images/icon-check-toast.svg" alt="Success"
      class="mr-3 h-6 w-6">
    <ng-icon *ngIf="toast.type !== 'success'" [name]="iconName" class="mr-3 h-6 w-6"
      [ngClass]="iconClass"></ng-icon>
    <span>{{ toast.message }}</span>
  </div>
  <button (click)="onRemove()" class="ml-4 text-gray-500 hover:text-gray-700">
    <ng-icon name="heroXMark" class="h-5 w-5"></ng-icon>
  </button>
</div>